'use client';

import FooterTrustpilot from '@ui/components/SiteFooter/components/FooterTrustpilot';
import FooterUsps from '@ui/components/SiteFooter/components/FooterUsps';
import FooterInfo from '@ui/components/SiteFooter/components/FooterInfo';
import FooterBar from '@ui/components/SiteFooter/components/FooterBar';
import { usePathname } from 'next/navigation';
import { useMemo } from 'react';
import useLocationHash from '@utils/hooks/useLocationHash';
import { useQuery } from '@tanstack/react-query';
import { getSiteFooterInfo } from '@app/actions/siteinfo/actions';
import { Dictionary } from '@ts/dictionary';

export default function SiteFooter() {
  const data = useQuery({
    queryKey: ['siteinfoFetchQuery'],
    queryFn: () => getSiteFooterInfo(),
  });
  const pathname = usePathname();
  const { hash } = useLocationHash();

  const style = useMemo(() => {
    if (pathname === '/checkout' && !hash?.includes('error')) {
      return {
        opacity: 0,
        height: 0,
        overflow: 'hidden',
      };
    }
  }, [pathname, hash]);

  const footerDictionary = useMemo(() => {
    const dictionary = data?.data?.siteInfoDictionary;
    if (dictionary) {
      return dictionary as Dictionary;
    }
    return undefined;
  }, [data?.data?.siteInfoDictionary]);

  const siteinfo = useMemo(() => {
    const currentSiteinfo = data?.data?.siteinfo;
    if (currentSiteinfo) {
      return currentSiteinfo;
    }
    return;
  }, [data?.data?.siteinfo]);

  if (data.isLoading || !footerDictionary) {
    return null;
  }

  return (
    <section className="-mt-px" style={style}>
      <FooterTrustpilot />
      <FooterUsps
        icons={siteinfo?.faviconCollection}
        logos={siteinfo?.siteLogoCollection}
        dictionary={footerDictionary}
      />
      <FooterInfo siteinfo={siteinfo} dictionary={footerDictionary} />
      <FooterBar
        paymentLogos={siteinfo?.paymentImagesCollection}
        shippingLogos={siteinfo?.shippingImagesCollection}
        copyright={siteinfo?.copyright}
        dictionary={footerDictionary}
      />
    </section>
  );
}
